import React from "react";
import { useSelector } from "react-redux";

import { getTenantConfig } from "ee/selectors/tenantSelectors";
import { getAssetUrl } from "ee/utils/airgapHelpers";
import pcBgLogo from "../../assets/images/login/pc-bg-logo.svg";

interface ContainerProps {
  title: string;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  disabledLoginForm?: boolean;
  testId?: string;
}

function Container(props: ContainerProps) {
  const { children, footer, subtitle, testId, title } = props;
  const tenantConfig = useSelector(getTenantConfig);
  return (
    <div
      className="flex items-center gap-20 my-auto min-w-min justify-center"
      data-testid={testId}
    >
      <div className="hidden md:flex justify-center items-center flex-col">
        <img src={pcBgLogo} alt="logo" className="w-[610px] h-[458px]" />
        <div className="login-bg-logo-title">AI驱动构建低代码应用</div>
      </div>
      <div className="px-6 w-[min(400px,80%)] flex flex-col gap-6 t--login-container h-[458px]">
        <img
          className="mx-auto login-img"
          src={getAssetUrl(tenantConfig.brandLogoUrl)}
        />
        {children}
        {footer}
      </div>
    </div>
  );
}

export default Container;
